import type { ReviewWithService } from '@/utils/centreStats';
import { formatDate } from '@/utils/formatters';
import { GoogleMark } from './GoogleMark';
import { ReviewText } from './ReviewText';
import { Stars } from './Stars';

/** One review as a plain list row: name (Google mark when imported), date, stars, text. */
export function ReviewCard({ r, className = '' }: { r: ReviewWithService; className?: string }) {
  const name = r.user?.trim() || 'Anonymous';
  return (
    <li className={`py-5 first:pt-2 ${className}`}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="flex items-center gap-1.5 text-sm font-semibold text-foreground">
            <span className="truncate">{name}</span>
            {r.source === 'google' && <GoogleMark className="size-3" />}
          </p>
          <p className="mt-0.5 text-xs text-muted-foreground">
            {[r.date ? formatDate(r.date) : null, r.serviceName].filter(Boolean).join(' · ')}
          </p>
        </div>
        {typeof r.rating === 'number' && <Stars value={r.rating} className="size-3.5" />}
      </div>
      {r.comment && <ReviewText text={r.comment} />}
    </li>
  );
}
